import { render, staticRenderFns } from "./UploadDeathImage.vue?vue&type=template&id=24474fdb"
import script from "./UploadDeathImage.vue?vue&type=script&lang=js"
export * from "./UploadDeathImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports